import { hasConsentFromBrowser } from 'libs/oneTrust/clientConsent';
import { ONETRUST_CATEGORIES, onConsentChange } from 'libs/oneTrust';

/**
 * Per-tab cache of the latest C0002 (Performance) consent value reported by
 * the central OneTrust dispatcher. `null` until the first dispatch — callers
 * fall back to the cookie/GPC check in that window so a slow SDK load does
 * not silently drop legitimate events.
 */
let lastDispatchedPerformanceConsent: boolean | null = null;
let subscribed = false;

/**
 * Subscribe to OneTrust consent changes so subsequent PII checks can answer
 * synchronously. Safe to call more than once; subsequent calls are no-ops.
 *
 * Called from `AnalyticsProvider` so the subscription is established before
 * any tracked interaction can fire.
 */
export function initConsentGate(): void {
  if (subscribed) return;
  subscribed = true;
  onConsentChange(activeGroups => {
    lastDispatchedPerformanceConsent = activeGroups.includes(ONETRUST_CATEGORIES.PERFORMANCE);
  });
}

/**
 * Whether C0002 (Performance) is currently consented. Prefers the dispatched
 * value when available; otherwise reads `OptanonConsent` + GPC directly so
 * pre-SDK calls still respect a returning user's prior choice.
 */
export function isPerformanceConsented(): boolean {
  if (lastDispatchedPerformanceConsent !== null) return lastDispatchedPerformanceConsent;
  return hasConsentFromBrowser(ONETRUST_CATEGORIES.PERFORMANCE);
}
